import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
} from 'reactstrap';
import moment from 'moment';
import { formatNumToPhone } from '../../utils/format-tel';

const RecordDetailModal = ({
  toggle,
  focusedId,
  record,
  showAgencies,
}) => (
  <Modal
    isOpen={focusedId === record.contact_id}
    toggle={toggle}
    className="mt-6 record-detail-modal"
    zIndex="100000"
  >
    <ModalHeader className="text-capitalize">
      {`Call Details: Agent ${record.agent_first_name} ${record.agent_last_name}`}
    </ModalHeader>
    <ModalBody className="p-0">
      <Table striped borderless size="sm" className="m-0">
        <tbody>
          <tr>
            <th>Enrollment ID</th>
            <td>{record.enrollment_id}</td>
          </tr>
          <tr>
            <th>Enrollment Last Updated</th>
            <td>{moment(record.enrollment_date).format('M/D/YY h:mma')}</td>
          </tr>
          <tr>
            <th>Lead ID</th>
            <td>{record.lead_id}</td>
          </tr>
          {showAgencies && (
            <tr>
              <th>Agency</th>
              <td>{record.agency_name}</td>
            </tr>
          )}
          <tr>
            <th>Agent Name</th>
            <td className="text-capitalize">
              {`${record.agent_last_name}, ${record.agent_first_name}`}
            </td>
          </tr>
          <tr>
            <th>Agent Broker #</th>
            <td>{record.agent_npn}</td>
          </tr>
          <tr>
            <th>Carrier</th>
            <td>{record.plan_carrier || '-'}</td>
          </tr>
          <tr>
            <th>Plan Type</th>
            <td>{record.plan_type}</td>
          </tr>
          <tr>
            <th>Client Name</th>
            <td className="text-capitalize">
              {`${record.client_last_name}, ${record.client_first_name}`}
            </td>
          </tr>
          <tr>
            <th>Phone Number Used</th>
            <td>{formatNumToPhone(record.phone_number)}</td>
          </tr>
          <tr>
            <th>Enrollment Status</th>
            <td>{record.enrollment_status ? 'Submitted' : 'Incomplete'}</td>
          </tr>
          <tr>
            <th>Call Start</th>
            <td>{moment(record.call_start).format('M/D/YY h:mm:ssa')}</td>
          </tr>
          <tr>
            <th>Call End</th>
            <td>{moment(record.call_end).format('M/D/YY h:mm:ssa')}</td>
          </tr>
          <tr>
            <th>Call Duration</th>
            <td>
              {moment.unix(record.call_duration).format('m[min] s[sec]')}
            </td>
          </tr>
          <tr>
            <th>Call ID</th>
            <td>{record.contact_id}</td>
          </tr>
        </tbody>
      </Table>
    </ModalBody>
    <ModalFooter>
      <Button color="white" onClick={toggle}>Close</Button>
    </ModalFooter>
  </Modal>
);

const mapStateToProps = (state) => ({
  focusedId: state.records.detailModalId,
  showAgencies: state.theme.features.agencies,
});

const mapDispatchToProps = {
  toggle: () => ({ type: 'TOGGLE_RECORD_DETAIL' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordDetailModal);
